export default class DefaultHandler {
  constructor(fieldType, overrides = []) {
    this.fieldTypes = Array.isArray(fieldType) ? fieldType : [fieldType];
    this.overrides = overrides;
  }

  canHandle(property) {
    return this.fieldTypes.includes(property.type);
  }

  handleField(property, defaultType) {
    const { id, name, label } = property;

    let formField = {
      id,
      name: label,
      type: defaultType || property.type,
    };

    if (this.overrides?.length) {
      const fieldOverride = this.overrides.find(({ id }) => id === name);
      if (fieldOverride) {
        formField = {
          ...formField,
          ...fieldOverride,
        };
      }
    }

    return formField;
  }
}
